import React, { FunctionComponent } from 'react';
import Skeleton from '@empiriecom/module-components/Skeleton';

const ShipmentInfosContainerSkeleton: FunctionComponent = (): JSX.Element => {
  return <Skeleton height="10rem" />;
};

export default ShipmentInfosContainerSkeleton;
